import Dashboard from "../components/Dashboard";
import FormLayoutDemo from "../components/FormLayoutDemo";
import Categories from "../components/Categories";
import Users from "../components/Users";
import Providers from "../components/Providers";
import Profile from "../pages/Profile";
import ProviderInfo from "../pages/ProviderInfo";
import Amenities from "../components/Amenities";
import SafetyRules from "../components/SafetyRules";
import Reports from "../components/Reports";
import Feedback from "../components/Feedback";
import UserView from "../components/UserView";
import BookingDetails from "../pages/BookingDetails";
import Payments from "../components/Payments";
import Bookings from "../components/Bookings";
import PromationsPlans from "../components/menu/PromationsPlans";
import Reviews from "../components/Reviews";
import CreateTermsCondition from "../views/Content/TermsCondition/Customer/CreateTermsCondition";
import TermsConditions from "../views/Content/TermsCondition/Customer/TermsConditions";
import ProviderTermsConditions from "../views/Content/TermsCondition/Provider/ProviderTermsConditions";
import CreateProviderTermsConditions from "../views/Content/TermsCondition/Provider/CreateProviderTermsCondition";
import PrivacyPolicy from "../views/Content/PrivacyPolicy/Customer/privacyPolicy";
import CreatePrivacyPolicy from "../views/Content/PrivacyPolicy/Customer/createPrivacyPolicy";
import ProviderPrivacyPolicy from "../views/Content/PrivacyPolicy/Provider/providerPrivacyPolicy";
import CreateProviderPrivacyPolicy from "../views/Content/PrivacyPolicy/Provider/createProviderPrivacyPolicy";

export const PrivateRoutes = [
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
    },
    {
        path: "/payments",
        name: "Payments",
        component: Payments,
    },
    {
        path: "/categories",
        name: "Categories",
        component: Categories,
    },
    {
        path: "/users",
        name: "Users",
        component: Users,
    },
    {
        path: "/providers",
        name: "Providers",
        component: Providers,
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/providerInfo/:id",
        name: "ProviderInfo",
        component: ProviderInfo,
    },

    {
        path: "/formlayout",
        name: "FormLayout",
        component: FormLayoutDemo,
    },
    {
        path: "/amenities",
        name: "Amenities",
        component: Amenities,
    },
    {
        path: "/safety-rules",
        name: "SafetyRules",
        component: SafetyRules,
    },
    {
        path: "/reports",
        name: "Reports",
        component: Reports,
    },
    {
        path: "/feedback",
        name: "FeedBack",
        component: Feedback,
    },
    {
        path: "/user-view/:id",
        name: "UserView",
        component: UserView,
    },
    {
        path: "/bookingDetail/:id",
        name: "BookingDetail",
        component: BookingDetails,
    },
    {
        path: "/bookings",
        name: "Bookings",
        component: Bookings,
    },
    {
        path: "/promationsplans",
        name: "PromationsPlans",
        component: PromationsPlans,
    },

    {
        path: "/reviews",
        name: "Reviews",
        component: Reviews,
    },
    {
        path: "/terms-conditions",
        name: "TermsConditions",
        component: TermsConditions,
    },
    {
        path: "/create-terms-conditions/",
        name: "CreateTermsCondition",
        component: CreateTermsCondition,
    },
    {
        path: "/provider-terms-conditions",
        name: "TermsConditions",
        component: ProviderTermsConditions,
    },
    {
        path: "/create-provider-terms-conditions/",
        name: "CreateTermsCondition",
        component: CreateProviderTermsConditions,
    },
    {
        path: "/privacy-policy",
        name: "PrivacyPolicy",
        component: PrivacyPolicy,
    },
    {
        path: "/create-privacy-policy/",
        name: "CreatePrivacyPolicy",
        component: CreatePrivacyPolicy,
    },
    {
        path: "/provider-privacy-policy",
        name: "ProviderPrivacyPolicy",
        component: ProviderPrivacyPolicy,
    },
    {
        path: "/create-provider-privacy-policy/",
        name: "CreateProviderPrivacyPolicy",
        component: CreateProviderPrivacyPolicy,
    },
];
